export const DetailsUpcmng = [
    {
        posterPath: 'webathon4.0.png',
        desc: "Webathon is a 24-hour hackathon organized at VNRVJIET with the objective of providing students with an experience comparable to industrial hackathons conducted by leading companies. The event served as a platform for students to collaborative, apply their technical knowledge to real-world challenges, and develop practical solutions within a constrained timeframe.",
        title: "Webathon ",
        target: '',
        regLink: "/webathon"
    },
    {
        posterPath: 'wcc6.png',
        desc: "Winter Coding Contest (WCC) is a nationwide coding competition conducted to offer students an opportunity to demonstrate their programming skills and evaluate their proficiency on a national scale. The contest aimed to promote a culture of competitive programming and foster the development of algorithmic thinking and problem-solving capabilities among participants.",
        title: 'Winter Coding Contest ',
        target: '_blank',
        regLink: "https://wcc6.pages.dev/"
    }
]